import { Component, EventEmitter, Input, Output, output } from '@angular/core';
import { AdamsDocModel } from '../../models/adams-doc-model';
import { MenuItem, MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { ClipboardService } from 'ngx-clipboard';
import { FoldersService } from '../../services/folders.service';
import { FormsService } from '../../services/forms.service';
import { QueryStateService } from '../../services/query-state.service';
import { ConstantsService } from '../../services/constants.service';
import { DocItemSearchModel } from '../../models/doc-item-search-model';
import { SearchResultsModel } from '../../models/search-results-model';
import { DocumentDownloadService } from '../../services/document-download.service';
import { DownloadRequest } from '../../models/download-req-model';

@Component({
  selector: 'app-doc-properties-list',
  templateUrl: './doc-properties-list.component.html',
  styleUrl: './doc-properties-list.component.css'
})
export class DocPropertiesListComponent {

  @Input() item: AdamsDocModel = {};
  @Output() closeDialog = new EventEmitter();
  showCopyMsg = false;
  shareDocPropItems: MenuItem[] = [];
  shareDocItems: MenuItem[] = [];
  goToFolderItems: MenuItem[] = [];
   currentIndex: string;

  constructor(private clipboardApi: ClipboardService,
    private msgService: MessageService,
    private formSvc: FormsService,
    private querySvc: QueryStateService,
    private router: Router,
    private folderSvc: FoldersService,
    private downloadDocSvc: DocumentDownloadService,
    public constants: ConstantsService) {
        this.currentIndex = this.constants.indexEHD;
  }

  ngOnInit(): void {
    const docItem: DocItemSearchModel = {
      id: this.item.Id ?? '',
      indexId: this.item.LibrarySource ?? ''
    };

    this.shareDocPropItems = [
      {
        label: 'Open Properties in New Tab',
        icon: 'fa-solid fa-up-right-from-square',
        url: '/props/' + encodeURIComponent(JSON.stringify(docItem)),
        target: '_blank'
      },
      {
        label: 'Copy Properties Link',
        icon: 'fa-regular fa-copy',
        command: () => this.copyPropertiesLink(),
      }
    ];
    this.shareDocItems = [
      {
        label: 'Download',
        icon: 'fa-solid fa-file-arrow-down',
        command: () => this.doDownload()
      }
    ];

    this.loadFolderItems();
  }

  loadFolderItems() {
    if (this.item.FoldersFiledIn && this.item.FoldersFiledIn.length > 0) {
      this.item.FoldersFiledIn.forEach(f => {
        this.goToFolderItems.push({
          label: f,
          icon: 'fa-solid fa-folder',
          command: () => this.goToFolder(f),
        });

      });
    }
  }

  doDownload() {
    let items: DownloadRequest = {accessionNumbers: [], indexId: this.currentIndex};

    if (!this.item.AccessionNumber)
    {
      return;
    }  
    
    items.accessionNumbers.push(this.item.AccessionNumber);
    this.msgService.add({ severity: 'success', summary: 'Document Download Started', detail: "Downloading Document with AccessionNumber '" + this.item.AccessionNumber + "'" });
    
     this.downloadDocSvc.getDocuments(items).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'documents.zip';
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        this.msgService.add({ severity: 'success', summary: 'Document Download Complete', detail: "Successfully downloaded Document with AccessionNumber '" + this.item.AccessionNumber + "'" });
      },
      error: (err) => {
        this.msgService.add({ severity: 'danger', summary: 'Document Download Failed', detail: "Failed to Download Document with AccessionNumber '" + this.item.AccessionNumber + "'" });
        console.error('[downloaddialog] Download Error', err);
      }
    });
  }

  goToFolder(path: string) {
    this.folderSvc.setSelectedFolder(path);

    this.querySvc.updateFormData(this.formSvc.initSearchForm().value);

    this.closeDialog.emit();
    this.router.navigate([
      '/home/'
    ]);
  }

  copyClipboard() {
    if (this.item.Url) {
      this.clipboardApi.copyFromContent(this.item.Url);
      this.showCopyMsg = true;
      this.msgService.add({ severity: 'success', summary: 'Document Link Copied', detail: 'Document Link Copied to Clipboard' });
    }
  }

  copyPropertiesLink() {
    if (this.item) {
      const docItem: DocItemSearchModel = {
        id: this.item.Id ?? '',
        indexId: this.item.LibrarySource ?? ''
      };
      let host = window.location.origin;
      let rUrl = this.router.createUrlTree(['/props/', encodeURIComponent(JSON.stringify(docItem))]);
      let link = host + rUrl;
      this.clipboardApi.copyFromContent(link);
      this.showCopyMsg = true;
      this.msgService.add({ severity: 'success', summary: 'Document Properties Copied', detail: 'Document Properties Link Copied to Clipboard' });
    }
  }
}

